export default "__VITE_ASSET__D1y82qdA__"